import dataService from '../../data/data.service';
import _ from 'lodash';
import store from '../store';

const state = {
  accounts: [],
  account: null
}

const getters = {
  accounts: (state) => {
    return state.accounts
  },
  account: (state) => {
    return state.account
  }
}

const actions = {
  
  get(context, params) {
    return new Promise((resolve) => {
      dataService.modules.account.get(params).then(data => {
        context.commit('get', data);
        resolve();
      });
    });
  },

  add(context, account) {
    return new Promise((resolve) => {
      dataService.modules.account.add(account).then(id => {
        context.commit('add',id.data[0]);
        resolve(id.data[0]);
      });
    });
  },

  update(context, account) {
    return new Promise((resolve) => {
      dataService.modules.account.update(account).then(() => {
        context.commit('update', account);
        resolve();
      });
    });
  },
  
}

const mutations = {
  get(state, data) {
    state.account = data;
  },
 
  add(state, data) {
    state.account.id = data;
  },

  update(state, data) {
    store.state.auth.user = data;
    state.account = data;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}